import { render, staticRenderFns } from "./TableMaterial.vue?vue&type=template&id=22240d12&"
import script from "./TableMaterial.vue?vue&type=script&lang=ts&"
export * from "./TableMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports